// ----------------------
// <auto-generated>
// Generated using the script apiGenerator.js
// </auto-generated>
// -----------------------
import { configuration } from 'config/constants';
import {
    AppContextsClient,
    ContractsClient,
    CustomerRequestsClient,
    CustomerRequestsDetailsClient,
    FinancialRequestsClient,
    HealthClient,
    HomeClient,
    InvoicesClient,
    LogsClient,
    PersonsClient,
    ReferentialsClient,
    SimulationsClient,
    SubscribeCodeClient,
} from './FranfinanceApiClient';
import { http } from 'services/ApiService/Http';

const { baseApiUrls: { franfinance: baseApiUrl } } = configuration;

export const AppContextsApi = new AppContextsClient(baseApiUrl, http);
export const ContractsApi = new ContractsClient(baseApiUrl, http);
export const CustomerRequestsApi = new CustomerRequestsClient(baseApiUrl, http);
export const CustomerRequestsDetailsApi = new CustomerRequestsDetailsClient(baseApiUrl, http);
export const FinancialRequestsApi = new FinancialRequestsClient(baseApiUrl, http);
export const HealthApi = new HealthClient(baseApiUrl, http);
export const HomeApi = new HomeClient(baseApiUrl, http);
export const InvoicesApi = new InvoicesClient(baseApiUrl, http);
export const LogsApi = new LogsClient(baseApiUrl, http);
export const PersonsApi = new PersonsClient(baseApiUrl, http);
export const ReferentialsApi = new ReferentialsClient(baseApiUrl, http);
export const SimulationsApi = new SimulationsClient(baseApiUrl, http);
export const SubscribeCodeApi = new SubscribeCodeClient(baseApiUrl, http);
